import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Landing } from "./components/Landing";
import { DemoPage } from "./components/DemoPage";
import { MindBriefDemo } from "./components/MindBriefDemo";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/demo/mindbrief" element={<MindBriefDemo />} />
        <Route path="/demo/:productId" element={<DemoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
